const CommonTitle = ({ img, title, text, rounded_img, children }) => {
  return (
    <div className="w-full  flex justify-center bg-white shadow-md ">
      <div className="w-full flex flex-row max-w-[1280px] md:px-10 px-[15px] py-8 gap-8 items-start md:items-center">
        <img
          src={img}
          alt={title}
          className={`h-20 ${rounded_img ? "rounded-full w-20" : ""}`}
        />
        <div className="w-full flex md:flex-row flex-wrap md:gap-y-[0px] gap-y-2 justify-between  items-center">
          <div className="flex flex-col gap-2">
            <h1 className="font-poppins text-dark-green text-xl md:text-2xl lg:text-3xl xl:text-4xl 2xl:text-3xl font-bold">
              {title}
            </h1>
            <h1 className="font-poppins text-dark-green text-md md:text-base lg:text-base xl:text-base 2xl:text-base font-medium">
              {text}
            </h1>
          </div>
          {children /*elemento adicional en algunos componentes*/}
        </div>
      </div>
    </div>
  );
};

export default CommonTitle;
